import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GiftCardsBase from '../GiftCardsBase';
import { setGiftCardCart } from '../../../Actions';
import { injectStripe, CardNumberElement} from 'react-stripe-elements';

class CardNumber extends GiftCardsBase {
  constructor(props){
    super(props);
    this.props.setGiftCardCart({
      ...this.props.giftCardCart,
      stripe: this.props.stripe
    });
  }


  render () {
    return (
        
      <CardNumberElement
      classes={{
        base: "stripe-cardnumber-element input-style",
      }}

      onChange={(obj)=>{
        if(this.props.onChange){
          this.props.onChange(obj);
        }
      }}

      hidePostalCode={true}
    />);
  }
}

const mapStateToProps = state => ({    
  giftCardCart: state.giftCardCart
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setGiftCardCart }, dispatch);
}

export default injectStripe(connect(mapStateToProps, mapDispatchToProps)(CardNumber));
